// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/eot/iranyekanwebregularfanum.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/woff/iranyekanwebregularfanum.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/ttf/iranyekanwebregularfanum.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/eot/iranyekanwebboldfanum.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/woff/iranyekanwebboldfanum.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/ttf/iranyekanwebboldfanum.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/eot/iranyekanwebextraboldfanum.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/woff/iranyekanwebextraboldfanum.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/ttf/iranyekanwebextraboldfanum.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: iranyekan;
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
* {
  box-sizing: border-box;
  font-family: iranyekan;
}

html,
body,
#root,
.App {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 10px;
  font-family: iranyekan;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

button {
  border: none;
  font-family: IRANYekanRegularRd, sans-serif;
}

a,
button {
  cursor: pointer;
}

a,
a:active,
a:visited {
  text-decoration: none;
  color: inherit;
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background: #d6d6d6;
  border: 0px none #ffffff;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #cfcfcf;
}

::-webkit-scrollbar-thumb:active {
  background: #c8c8c8;
}

::-webkit-scrollbar-track {
  background: #fcfcfc;
  border: 0px none #ffffff;
  border-radius: 50px;
}

::-webkit-scrollbar-track:hover {
  background: #ffffff;
}

::-webkit-scrollbar-track:active {
  background: #ffffff;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

.ant-pagination-next,
.ant-pagination-prev {
  border: 1px solid #a05195;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/_assets/styles/global.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,4LAAA;AACF;AAIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,4LAAA;AAFF;AAMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,4LAAA;AAJF;AAUA;EACE,sBAAA;EACA,sBAAA;AARF;;AAUA;;;;EAIE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;AAPF;;AASA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AANF;;AAQA;EACE,YAAA;EACA,2CAAA;AALF;;AAOA;;EAEE,eAAA;AAJF;;AAMA;;;EAGE,qBAAA;EACA,cAAA;AAHF;;AAMA;EACE,UAAA;EACA,WAAA;AAHF;;AAKA;EACE,UAAA;EACA,WAAA;AAFF;;AAIA;EACE,mBAAA;EACA,wBAAA;EACA,kBAAA;AADF;;AAGA;EACE,mBAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,mBAAA;EACA,wBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AADA;EACE,mBAAA;AAIF;;AAFA;EACE,uBAAA;AAKF;;AAHA;;EAEE,yBAAA;EACA,sBAAA;AAMF","sourcesContent":["@font-face {\n  font-family: iranyekan;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../fonts/eot/iranyekanwebregularfanum.eot\");\n  src: url(\"../fonts/eot/iranyekanwebregularfanum.eot\")\n      format(\"embedded-opentype\"),\n    url(\"../fonts/woff/iranyekanwebregularfanum.woff\") format(\"woff\"),\n    url(\"../fonts/ttf/iranyekanwebregularfanum.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: iranyekan;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"../fonts/eot/iranyekanwebboldfanum.eot\");\n  src: url(\"../fonts/eot/iranyekanwebboldfanum.eot\") format(\"embedded-opentype\"),\n    url(\"../fonts/woff/iranyekanwebboldfanum.woff\") format(\"woff\"),\n    url(\"../fonts/ttf/iranyekanwebboldfanum.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: iranyekan;\n  font-style: normal;\n  font-weight: 800;\n  src: url(\"../fonts/eot/iranyekanwebextraboldfanum.eot\");\n  src: url(\"../fonts/eot/iranyekanwebextraboldfanum.eot\")\n      format(\"embedded-opentype\"),\n    url(\"../fonts/woff/iranyekanwebextraboldfanum.woff\") format(\"woff\"),\n    url(\"../fonts/ttf/iranyekanwebextraboldfanum.ttf\") format(\"truetype\");\n}\n\n* {\n  box-sizing: border-box;\n  font-family: iranyekan;\n}\nhtml,\nbody,\n#root,\n.App {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  font-size: 10px;\n  font-family: iranyekan;\n}\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\nbutton {\n  border: none;\n  font-family: IRANYekanRegularRd, sans-serif;\n}\na,\nbutton {\n  cursor: pointer;\n}\na,\na:active,\na:visited {\n  text-decoration: none;\n  color: inherit;\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n  height: 7px;\n}\n::-webkit-scrollbar-button {\n  width: 0px;\n  height: 0px;\n}\n::-webkit-scrollbar-thumb {\n  background: #d6d6d6;\n  border: 0px none #ffffff;\n  border-radius: 5px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #cfcfcf;\n}\n::-webkit-scrollbar-thumb:active {\n  background: #c8c8c8;\n}\n::-webkit-scrollbar-track {\n  background: #fcfcfc;\n  border: 0px none #ffffff;\n  border-radius: 50px;\n}\n::-webkit-scrollbar-track:hover {\n  background: #ffffff;\n}\n::-webkit-scrollbar-track:active {\n  background: #ffffff;\n}\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n.ant-pagination-next,\n.ant-pagination-prev {\n  border: 1px solid #a05195;\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
